import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useVendorStore from "../../AuthStore/store/authStore";
import AlertModal from "../Modal/AlertModel";
// adjust import path as per your project

const Login = () => {
  const navigate = useNavigate();
  const formRef = useRef();
  const { LoginAsVendor, LoggedInAsUser } = useVendorStore();

  // Default: customer login
  const [selectedForm, setSelectedForm] = useState("customer");

  const [formData, setFormData] = useState({
    vendor_id: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  // 🔔 Alert modal states
  const [open, setOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    title: "",
    message: "",
    type: "info",
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Submit (both forms use same handler for now)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      if (selectedForm === "broker") {
        const res = await LoginAsVendor(formData.vendor_id);
        // console.log("Broker login response:", res);

        setAlertData({
          title: "Broker Login",
          message: res?.message || "Broker OTP sent!",
          type: "success",
        });
        setOpen(true);

        navigate(`/auth/otp-verify?id=${formData.vendor_id}`);
      } else {
        const res = await LoggedInAsUser(formData);

        
         
       

        setAlertData({
          title: "Customer Login",
          message: res.message || "OTP sent successfully!",
          type: "success",
        });
        
        setOpen(true);

        navigate("/auth/verify/customer-dashbord");
      }
    } catch (error) {
      console.error("Login error:",error);

      setAlertData({
        title: "Error!",
        message:"Opps ! Invalid credentials!",
        type: "error",
      });
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-white p-8 rounded-2xl shadow-lg space-y-4"
      >
        {/* Top toggle buttons */}
        <div className="flex justify-center gap-4 mb-4">
          <button
            type="button"
            onClick={() => setSelectedForm("customer")}
            className={`px-4 py-2 rounded ${
              selectedForm === "customer"
                ? "bg-green-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            Customer Login
          </button>
          <button
            type="button"
            onClick={() => setSelectedForm("broker")}
            className={`px-4 py-2 rounded ${
              selectedForm === "broker"
                ? "bg-indigo-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            Broker Login
          </button>
        </div>

        <h2 className="text-2xl font-semibold text-center text-gray-700 mb-4">
          {selectedForm === "broker" ? "Broker Login" : "Customer Login"}
        </h2>

        {/* Conditional input fields */}
        {selectedForm === "broker" ? (
          <input
            type="text"
            name="vendor_id"
            placeholder="Broker ID"
            value={formData.vendor_id}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none transition"
          />
        ) : (
          <>
            <input
              type="email"
              name="email"
              placeholder="Enter your Email id"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none transition"
            />
            <input
              type="password"
              name="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none transition"
            />
          </>
        )}

        <button
  type="submit"
  className="w-full px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition disabled:opacity-50"
  disabled={loading}
>
  {loading
    ? selectedForm === "broker"
      ? "Sending OTP..."
      : "Logging in..."
    : selectedForm === "broker"
    ? "Send OTP"
    : "Login"}
</button>

      </form>

      {/* 🔔 Alert Modal */}
      <AlertModal
        isOpen={open}
        onClose={() => setOpen(false)}
        title={alertData.title}
        message={alertData.message}
        type={alertData.type}
      />
    </div>
  );
};

export default Login;
